import React from "react";
import { Draggable } from "react-beautiful-dnd";

import DragHandlerIcon from "@atlaskit/icon/glyph/drag-handler";

import { EnhancedTableRow } from "../EnhancedTableRow";
import { DraggableTableCell } from "../DraggableTableCell";
import { Switch } from "../../components/Switch";

import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { disclaimerFormatter, tagFormatter } from "../../helpers/disclaimerFormatter";
import { TableRowOptions } from "../TableRowOptions";
import { Box } from "../../UI/Box";
import { COLOR_ATHENS_GRAY_DARKER_2 } from "../../constants/styles";

import useAuth from "../../routes/login/AuthContext";

interface IProps {
  idx: number;
  id: string;
  questionText: string;
  disclaimer: string;
  retainAnswer: boolean;
  answers: any;
  showTagColumn?: any;
  tag?: {
    name: string;
    id: number;
  };
  handleEdit: VoidFunction;
  handleDelete: VoidFunction;
  editDisabled: boolean;
  toggleRetainAnswer: VoidFunction;
  isLoading: boolean;
}

export const SelectQuestionsTableBodyRow: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();

  return (
    <Draggable index={props.idx} draggableId={"" + props.id} isDragDisabled={isSuperAdminRead() || props.editDisabled}>
      {(propvided, snapshot) => (
        <EnhancedTableRow hover {...propvided.draggableProps} ref={propvided.innerRef} isDragging={snapshot.isDragging}>
          <DraggableTableCell {...propvided.dragHandleProps} isDragOccurring={snapshot.isDragging}>
            <ReadOnlyWrapper>
              <Box width={32} height={32} display="flex" alignItems="center" justifyContent="center">
                <DragHandlerIcon label="Drag icon" size="large" />
              </Box>
            </ReadOnlyWrapper>
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={snapshot.isDragging}>{props.questionText}</DraggableTableCell>
          <DraggableTableCell isDragOccurring={snapshot.isDragging}>
            {props.answers.map((answer: any, idx: number) => (
              <Box
                bgcolor={COLOR_ATHENS_GRAY_DARKER_2}
                px={1}
                py="2px"
                mb={0.5}
                width="fit-content"
                borderRadius="4px"
                key={idx}
              >
                {answer.answerText}
              </Box>
            ))}
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={snapshot.isDragging}>
            {disclaimerFormatter(props.disclaimer)}
          </DraggableTableCell>
          {props.showTagColumn && (
            <DraggableTableCell isDragOccurring={snapshot.isDragging}>{tagFormatter(props.tag?.name)}</DraggableTableCell>
          )}
          <DraggableTableCell isDragOccurring={snapshot.isDragging}>
            <TableRowOptions handleEdit={props.handleEdit} handleDelete={props.handleDelete} editDisabled={props.editDisabled} >
              <Switch
                isDisabled={isSuperAdminRead() || props.editDisabled}
                switchProps={{
                  checked: props.retainAnswer,
                  onChange: props.toggleRetainAnswer,
                }}
              />
            </TableRowOptions>
          </DraggableTableCell>
        </EnhancedTableRow>
      )}
    </Draggable>
  );

};